import React, { useEffect, useState } from 'react';
import { SxStyle } from '../../../../../types';
import { useStringsContext } from '../../../../../contexts/strings';
import { SquadPlayer } from '../../types';
import { CurrentClub } from '../../api-types';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import TableBody from '@mui/material/TableBody';
import PlayerTabContent from './player-tab-content';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';

interface FilteredClub extends Pick<CurrentClub, 'contractUntil' | 'contractType' | 'joined'> {}

const filteredClubKeys: (keyof FilteredClub)[] = ['contractUntil', 'contractType', 'joined'];

interface DataRowsType {
  key: keyof FilteredClub;
  value: FilteredClub[keyof FilteredClub] | null;
}

const styles: SxStyle = {
  tableRow: (theme) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.shades.p10,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }),
};

interface Props {
  teamId: string;
  player: SquadPlayer;
  onEditPlayer: () => void;
  season: number;
  isReadOnly?: boolean;
}

const { REACT_APP_DEFAULT_LEAGUE_SEASON } = process.env;
const CURRENT_YEAR = parseInt(REACT_APP_DEFAULT_LEAGUE_SEASON as string, 10);
const PlayerTabContract = ({ teamId, player, onEditPlayer, season, isReadOnly }: Props) => {
  const { strings } = useStringsContext();
  const [rows, setRows] = useState<DataRowsType[] | null>(null);

  let currentClub: CurrentClub | null | undefined = null;
  if (Array.isArray(player.currentClub)) {
    currentClub = player.currentClub?.find((club) => club.id === teamId);
  }

  useEffect(() => {
    const dataRows = filteredClubKeys.map((key) => {
      return { key: key, value: currentClub && currentClub[key] };
    });
    setRows(dataRows);
  }, [currentClub, player]);

  if (!rows) {
    return <></>;
  }

  return (
    <PlayerTabContent
      title={strings.squadPlayerTabs.contract}
      buttonElement={
        <Button
          variant="contained"
          onClick={onEditPlayer}
          startIcon={<EditIcon />}
          disabled={season !== CURRENT_YEAR || isReadOnly}
        >
          {strings.squad.edit}
        </Button>
      }
    >
      <TableBody>
        {rows?.map((row) => (
          <TableRow key={row.key} sx={styles.tableRow}>
            <TableCell width={300}>
              <Typography variant="subtitle2">{strings.squadPlayer[row.key]}</Typography>
            </TableCell>
            <TableCell>
              {row.value || (
                <Typography variant="italic">{strings.squad.missingInformation}</Typography>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </PlayerTabContent>
  );
};

export default PlayerTabContract;
